import * as React from "react";
import type { SVGProps } from "react";
const SvgDankort = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#e41d27"
      d="m17.79 11.442 3.169 3.768A5.84 5.84 0 0 0 22 11.874c0-1.306-.43-2.515-1.154-3.491zM8.814 8.064c2.366 0 4.148.602 4.332 2.596l2.49-2.596h4.957A5.87 5.87 0 0 0 16.125 6H6.6c-1.787 0-3.39.802-4.469 2.064zm-3.898 2.513L4.071 12.9H7.48c1.007 0 1.312-.417 1.538-1.22.223-.795-.338-1.103-1.026-1.103zm10.74 4.95-2.633-3.328c-.487 2.27-2.081 3.328-5.069 3.328H2a5.87 5.87 0 0 0 4.599 2.223h9.526c1.86 0 3.521-.87 4.598-2.223z"
    />
  </svg>
);
export default SvgDankort;
